import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';

const OrdersModalCell = ({ rowData }) => {
	const sub_value = rowData.sub_value;

	if (rowData.id === 'maxWeight') {
		return (
			<span>
				<b className="orders-modal-cell__bold">Коэффициент утилизации:</b>{' '}
				{sub_value !== null && sub_value !== undefined ? sub_value : '---'}
			</span>
		);
	}
	if (rowData.id === 'maxVolume') {
		return (
			<span>
				<b className="orders-modal-cell__bold">Коэффициент утилизации:</b>{' '}
				{sub_value !== null && sub_value !== undefined ? sub_value : '---'}
			</span>
		);
	}

	return null;
};

OrdersModalCell.propTypes = {
	rowData: PropTypes.shape({
		id: PropTypes.string.isRequired,
		sub_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}).isRequired,
	columnId: PropTypes.string.isRequired,
};

export { OrdersModalCell };
